var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"my-5",attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","sm8":"","offset-sm2":"","md6":"","offset-md3":"","lg4":"","offset-lg4":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }